import { ORGANIZATION_SLUG } from 'service/constants'
import constants from 'constants/index'

// Quando a rota cai num slug default (ex.: o backend força /dponet/sso/error) mas
// há um slug white-label salvo no storage, retorna o mesmo path/query trocando o
// primeiro segmento pelo slug salvo — para o componente redirecionar e manter o
// white-label na URL. Retorna null quando não há nada a trocar.
const storedSlugRedirectPath = (slug, pathname, search = '') => {
  const { DEFAULT_SLUGS_PATHS } = constants.settings

  const isDefaultSlug =
    !slug || DEFAULT_SLUGS_PATHS.includes(slug?.toLowerCase())
  if (!isDefaultSlug) return null

  const storedSlug = sessionStorage.getItem(ORGANIZATION_SLUG)
  if (!storedSlug || DEFAULT_SLUGS_PATHS.includes(storedSlug?.toLowerCase()))
    return null

  const pathWithoutSlug = pathname.replace(/^\/[^/]+/, '')
  return `/${storedSlug}${pathWithoutSlug}${search}`
}

export default storedSlugRedirectPath
